import { regionIds } from './regionIds';
import { getLanguagesByRegionId } from './languages';
import { languageIds } from './languageIds';
import { unitIds } from './unitIds';
import MiniCADAPI from '../MiniCADAPI';

export const getRegionById = ( regionId ) => {
    return regions.find(region => region.id === regionId && region.active === true);
};

export const getActiveRegions = () => {
    return regions.filter(region => {
        return region.active === true;
    })
}

export const regions = [
  {
    id: regionIds.usa,
    name: 'USA',
    languages: getLanguagesByRegionId(regionIds.usa),
    defaultLanguageId: languageIds.enUS,
    unitId: unitIds.imperial,
    active: true,
  },
  {
    id: regionIds.mexico,
    name: 'México',
    languages: getLanguagesByRegionId(regionIds.mexico),
    defaultLanguageId: languageIds.esES,
    unitId: unitIds.metric,
    active: false,
  },
  {
    id: regionIds.canada,
    name: 'Canada',
    languages: getLanguagesByRegionId(regionIds.canada),
    defaultLanguageId: languageIds.enUS,
    unitId: unitIds.metric,
    active: true,
  },
  {
    id: regionIds.europe,
    name: 'Europe',
    languages: getLanguagesByRegionId(regionIds.europe),
    defaultLanguageId: languageIds.enGB,
    unitId: unitIds.metric,
    active: false,
  },
  {
    id: regionIds.centralAmerica,
    name: 'Central America',
    languages: getLanguagesByRegionId(regionIds.centralAmerica),
    defaultLanguageId: languageIds.enUS,
    unitId: unitIds.metric,
    active: false,
  },

  {
    id: regionIds.southAmerica,
    name: 'South America',
    languages: getLanguagesByRegionId(regionIds.southAmerica),
    defaultLanguageId: languageIds.enUS,
    unitId: unitIds.metric,
    active: false,
  },
  {
    id: regionIds.africa,
    name: 'Africa',
    languages: getLanguagesByRegionId(regionIds.africa),
    defaultLanguageId: languageIds.enUS,
    unitId: unitIds.metric,
    active: false,
  },
  {
    id: regionIds.asia,
    name: 'Asia',
    languages: getLanguagesByRegionId(regionIds.asia),
    defaultLanguageId: languageIds.enUS,
    unitId: unitIds.metric,
    active: false,
  },
  {
    id: regionIds.oceania,
    name: 'Oceania',
    languages: getLanguagesByRegionId(regionIds.oceania),
    defaultLanguageId: languageIds.enUS,
    unitId: unitIds.metric,
    active: false,
  },
  {
    id: regionIds.australia,
    name: 'Australia',
    languages: getLanguagesByRegionId(regionIds.australia),
    defaultLanguageId: languageIds.enUS,
    unitId: unitIds.metric,
    active: false,
  },
  {
    id: regionIds.middleEast,
    name: 'Middle East',
    languages: getLanguagesByRegionId(regionIds.middleEast),
    defaultLanguageId: languageIds.enUS,
    unitId: unitIds.metric,
    active: false,
  },
  {
    id: regionIds.caribbean,
    name: 'Caribbean',
    languages: getLanguagesByRegionId(regionIds.caribbean),
    defaultLanguageId: languageIds.enUS,
    unitId: unitIds.metric,
    active: false,
  },
];

export const saveUserLocalizationDefaults = async (
  userId,
  regionId,
  languageId,
  unitId,
  token,
  county = "",
  mailingList = false
) => {
  const result = await MiniCADAPI.upsertUserRecord(
    {
      userId,
      regionId,
      languageId,
      unit: unitId,
      county,
      mailingList
    },
    token
  );
  return result;
};



// WEBPACK FOOTER //
// ./src/lib/localization/regions.js